/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Keep the PDP "Add to Quote" button's title (= SKU) in sync with the selected
 * variant. The external quote.js handler reads the SKU from the button's title
 * attribute; without it the quote modal opens but the product is not added.
 *
 * Scoped to the two main PDP quote buttons only — the related-product carousel
 * and grid cards already render their own per-product title and must not be
 * touched here.
 */
(function () {
  var PDP_QUOTE_SELECTOR =
    '.kg-btn-add-quotes .button_quote_click, .kg-more-product-button.button_quote_click';

  function updatePdpQuoteSku(sku) {
    if (sku == null) return;
    document.querySelectorAll(PDP_QUOTE_SELECTOR).forEach(function (btn) {
      btn.setAttribute('title', sku);
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event && event.detail && event.detail.variant;
    if (variant) updatePdpQuoteSku(variant.sku);
  });
})();


/**
 * Product add-ons ("Recommended add-ons"): "Add to cart" on each add-on card.
 *
 * The cards render inside the main product <form>, so we cannot use a nested
 * <form> here. Instead each button carries data-variant-id, we POST to
 * /cart/add.js ourselves, then use the theme's public "product:added" hook
 * (documented at the top of this file) so the mini-cart refreshes and the
 * drawer opens exactly like the main add-to-cart button.
 */
(function () {
  var ADDON_ADD_SELECTOR = '[data-addon-add]';

  function onAddonAddClick(event) {
    var button = event.target.closest(ADDON_ADD_SELECTOR);
    if (!button || button.hasAttribute('disabled')) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalHtml = button.innerHTML;
    var addUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add';

    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading');

    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        button.removeAttribute('disabled');
        button.classList.remove('is-loading');

        if (result.ok) {
          document.documentElement.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: { quantity: 1 }
            })
          );
        } else {
          var message =
            (result.data && result.data.description) || 'Could not add to cart';
          button.innerHTML = message;
          setTimeout(function () {
            button.innerHTML = originalHtml;
          }, 2500);
        }
      })
      .catch(function () {
        button.removeAttribute('disabled');
        button.classList.remove('is-loading');
        button.innerHTML = originalHtml;
      });
  }

  document.addEventListener('click', onAddonAddClick);
})();


/**
 * Product add-ons: resolve addon_<variant-id> tags into cards.
 *
 * snippets/product-addons.liquid can only emit the variant IDs — Liquid looks
 * products up by handle and has no way to resolve a variant ID at all. So the
 * snippet renders skeletons plus a data-addon-variant-ids list, and this
 * resolver turns them into real cards with one Storefront API request per page.
 *
 * The generated buttons carry data-addon-add and a numeric data-variant-id, so
 * the delegated handler above picks them up with no extra wiring.
 *
 * Prices are emitted as the same .kg-excluding-price / .kg-including-price pair
 * the rest of the theme uses, so the CSS-only GST toggle in kg-custom.css swaps
 * them along with every other price on the page.
 */
(function () {
  var ROOT_SELECTOR = '[data-addons-root][data-addons-state="loading"]';
  var IMAGE_HEIGHT_DESKTOP = 120;
  // Page-lifetime only: these prices feed a GST calculation, so they must not
  // outlive the page the way sessionStorage would.
  var variantCache = Object.create(null);

  /* ---------------------------------------------------------------- money -- */

  /**
   * Format integer cents using the shop's money format. The theme has no
   * shared JS money formatter (kg-custom.js has a local one, but it is not
   * exported and drops thousands separators), so this is deliberately local.
   */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';

    // money_format may wrap the amount in markup (e.g. "<span class=money>${{amount}}</span>").
    // Cards are built with textContent, so strip tags rather than render them literally.
    format = format.replace(/<[^>]*>/g, '');

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      var value = cents / 100;

      switch (name) {
        case 'amount':
          return withSeparators(value.toFixed(2), ',', '.');
        case 'amount_no_decimals':
          return withSeparators(Math.round(value).toString(), ',', '');
        case 'amount_with_comma_separator':
          return withSeparators(value.toFixed(2), '.', ',');
        case 'amount_with_apostrophe_separator':
          return withSeparators(value.toFixed(2), "'", '.');
        default:
          return match;
      }
    });
  }

  function withSeparators(numberString, thousands, decimal) {
    var parts = numberString.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    if (!decimal || parts.length < 2) return whole;
    return whole + decimal + parts[1];
  }

  /**
   * Storefront API MoneyV2.amount is a decimal string in dollars ("2664.20"),
   * unlike the /cart/*.js endpoints which use integer cents. Normalise here so
   * nothing downstream has to know which convention it is holding.
   */
  function toCents(amount) {
    if (amount == null) return null;
    var value = parseFloat(amount);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  /**
   * Prices are stored inc GST. product-price.liquid derives the ex-GST figure
   * with `price | times: 100 | divided_by: 110`, which is integer division and
   * therefore floors — match it exactly, or add-on prices land a cent away from
   * the same product's own page.
   */
  function exGstCents(cents) {
    return Math.floor((cents * 100) / 110);
  }

  /* ------------------------------------------------------------ elements -- */

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  /** Both GST variants of one money value, as the theme renders them. */
  function appendGstPair(parent, tag, className, cents) {
    var ex = el(tag, 'kg-excluding-price', formatMoney(exGstCents(cents)));
    var inc = el(tag, 'kg-including-price', formatMoney(cents));

    if (className) {
      ex.classList.add(className);
      inc.classList.add(className);
    }

    parent.appendChild(ex);
    parent.appendChild(inc);
  }

  /** Only allow Shopify CDN images; anything else falls back to a placeholder. */
  function safeImageUrl(url) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol !== 'https:') return null;
      if (!/(^|\.)cdn\.shopify\.com$/.test(parsed.hostname)) return null;
      return parsed.href;
    } catch (e) {
      return null;
    }
  }

  function gidToId(gid) {
    if (!gid) return null;
    var parts = String(gid).split('/');
    var id = parts[parts.length - 1];
    return /^\d+$/.test(id) ? id : null;
  }

  /* ---------------------------------------------------------------- card -- */

  function buildCard(variant, config) {
    var variantId = gidToId(variant.id);
    if (!variantId) return null;

    var product = variant.product || {};
    var title = product.title || variant.title || '';
    var image = variant.image || product.featuredImage || null;
    var priceCents = toCents(variant.price && variant.price.amount);
    var compareCents = toCents(variant.compareAtPrice && variant.compareAtPrice.amount);

    var item = el('li', 'addons__item');
    var card = el('div', 'addons__card');
    var link = el('a', 'addons__link');

    link.href =
      product.onlineStoreUrl ||
      config.rootUrl + 'products/' + encodeURIComponent(product.handle || '');

    var imageWrapper = el('span', 'addons__image-wrapper');
    var imageUrl = safeImageUrl(image && image.url);

    if (imageUrl) {
      var img = el('img', 'addons__image');
      img.src = imageUrl;
      img.alt = (image && image.altText) || title;
      img.loading = 'lazy';
      img.width = 300;
      img.height = IMAGE_HEIGHT_DESKTOP;
      imageWrapper.appendChild(img);
    } else {
      var placeholder = el('span', 'addons__image addons__image--placeholder');
      placeholder.setAttribute('aria-hidden', 'true');
      imageWrapper.appendChild(placeholder);
    }

    link.appendChild(imageWrapper);

    var info = el('span', 'addons__info');
    info.appendChild(el('span', 'addons__name', title));

    var price = el('span', 'addons__price');
    if (priceCents != null) {
      appendGstPair(price, 'span', null, priceCents);

      if (compareCents != null && compareCents > priceCents) {
        appendGstPair(price, 's', 'addons__price-compare', compareCents);
      }
    }
    info.appendChild(price);

    link.appendChild(info);
    card.appendChild(link);

    if (variant.availableForSale) {
      var button = el(
        'button',
        'addons__add button button--primary button--small'
      );
      button.type = 'button';
      button.setAttribute('data-addon-add', '');
      button.setAttribute('data-variant-id', variantId);
      button.setAttribute('aria-label', config.labelAdd + ': ' + title);
      button.appendChild(el('span', 'addons__add-label', config.labelAdd));
      card.appendChild(button);
    } else {
      card.appendChild(el('span', 'addons__soldout', config.labelSoldOut));
    }

    item.appendChild(card);
    return item;
  }

  /* ----------------------------------------------------------- resolving -- */

  var QUERY = [
    'query addonVariants($ids: [ID!]!) {',
    '  nodes(ids: $ids) {',
    '    ... on ProductVariant {',
    '      id',
    '      title',
    '      availableForSale',
    '      price { amount }',
    '      compareAtPrice { amount }',
    '      image { url(transform: {maxWidth: 300}) altText }',
    '      product {',
    '        title',
    '        handle',
    '        onlineStoreUrl',
    '        featuredImage { url(transform: {maxWidth: 300}) altText }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  function fetchVariants(ids, config) {
    var missing = ids.filter(function (id) {
      return !(id in variantCache);
    });

    if (missing.length === 0) return Promise.resolve();

    // The Storefront API lives at the domain root, not under a Markets subfolder.
    var endpoint = '/api/' + config.apiVersion + '/graphql.json';

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token
      },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          ids: missing.map(function (id) {
            return 'gid://shopify/ProductVariant/' + id;
          })
        }
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (payload.errors || !payload.data || !payload.data.nodes) {
          throw new Error(
            (payload.errors && payload.errors[0] && payload.errors[0].message) ||
              'Storefront API returned no data'
          );
        }

        // nodes() preserves input order and yields null for unresolvable IDs.
        payload.data.nodes.forEach(function (node, index) {
          variantCache[missing[index]] = node && node.id ? node : null;
        });
      });
  }

  function render(root, config) {
    var list = root.querySelector('[data-addons-list]');
    if (!list) return;

    var fragment = document.createDocumentFragment();
    var unresolved = [];
    var rendered = 0;

    config.ids.forEach(function (id) {
      var variant = variantCache[id];
      if (!variant) {
        unresolved.push(id);
        return;
      }

      var card = buildCard(variant, config);
      if (!card) {
        unresolved.push(id);
        return;
      }

      fragment.appendChild(card);
      rendered += 1;
    });

    if (rendered === 0) {
      root.remove();
      console.warn(
        '[product-addons] No add-on variants resolved; block removed. IDs: ' +
          config.ids.join(', ')
      );
      return;
    }

    if (unresolved.length) {
      console.warn(
        '[product-addons] Skipped unresolvable variant IDs: ' + unresolved.join(', ')
      );
    }

    // One atomic write: skeletons out, cards in.
    list.replaceChildren(fragment);

    root.removeAttribute('aria-busy');
    root.setAttribute('data-addons-state', 'ready');

    var status = root.querySelector('[data-addons-status]');
    if (status) {
      status.textContent = rendered + ' add-ons loaded';
    }
  }

  function readConfig(root) {
    var ids = (root.getAttribute('data-addon-variant-ids') || '')
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(function (id) {
        return /^\d+$/.test(id);
      });

    return {
      ids: ids,
      token: root.getAttribute('data-storefront-token') || '',
      apiVersion: root.getAttribute('data-api-version') || '2025-01',
      // routes.root_url has no trailing slash on Markets subfolders ("/en-au").
      rootUrl: (root.getAttribute('data-root-url') || '/').replace(/\/?$/, '/'),
      labelAdd: root.getAttribute('data-label-add') || 'Add to cart',
      labelSoldOut: root.getAttribute('data-label-soldout') || 'Sold out'
    };
  }

  function resolveRoot(root) {
    // Flip state before doing any async work, so a concurrent scan skips this root.
    root.setAttribute('data-addons-state', 'resolving');

    var config = readConfig(root);

    if (!config.ids.length) {
      root.remove();
      return;
    }

    if (!config.token) {
      root.remove();
      console.warn(
        '[product-addons] No Storefront API token configured ' +
          '(Theme settings > Product add-ons); add-ons cannot be shown.'
      );
      return;
    }

    fetchVariants(config.ids, config)
      .then(function () {
        render(root, config);
      })
      .catch(function (error) {
        root.remove();
        console.warn('[product-addons] Could not resolve add-ons:', error);
      });
  }

  function scan() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(resolveRoot);
  }

  /**
   * Re-scan after DOM changes. A "product:rerender" listener would not work
   * here: theme.js dispatches that event on the product <form> without
   * bubbles, so it never reaches the document. An observer also covers the
   * quick-view modal and the featured-product section for free, and the
   * variant cache means a re-render of the same product does no network work.
   */
  var scanQueued = false;

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  function observe() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          queueScan();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    scan();
    observe();
  }

  // custom.js is loaded without defer, so the add-ons block may not be parsed yet.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


